<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small"  label-width="100px">
                    <el-form-item label="团队名称"><el-input v-model="queryParams.name" placeholder="团队名称"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd" v-has="'btn_add'">添加</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable"
					tooltip-effect="dark" @selection-change="handleSelectionChange" @sort-change="sortChange" :default-sort="queryParams.defaultSort">
                    <el-table-column prop="name" label="团队名称"></el-table-column>
                    <el-table-column prop="description" label="团队描述"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column fixed="right" label="操作" :width="width">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleDeviceShare(scope.row)"  v-has="'btn_share_device'">分配设备</el-button>
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-has="'btn_edit'">编辑</el-button>
							<el-button size="mini" type="danger" @click="batchUpdateStatus(-1,'删除',scope.row.id)"  v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage" :page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 添加/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
			<el-form  :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="120px">
                <el-form-item label="团队名称" prop="name"><el-input type="text" v-model="addOrUpdateForm.name"></el-input></el-form-item>
                <el-form-item label="团队描述" prop="description">
					<el-input   type="textarea" :autosize="{ minRows: 5}" v-model="addOrUpdateForm.description"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>
		
		<devicesShare ref="devicesShare"  bizType='team' ></devicesShare>
	</div>
</template>

<script>
import BaseSearch from '@/components/layout/base/base-search-front';
	import devicesShare from '@/components/layout/devices/devicesShare';

export default {
	extends: BaseSearch,
	components: {
		devicesShare
	},
	data() {
		return {
			url: 'team',
			name: '团队',
			rules: {
                name: [
                     { required: true, message: '请输入团队名称', trigger: 'blur' },
                     { max: 100, message: '长度最长支持100', trigger: 'blur' }
                 ],
			}
		};
	},
	filters:{
	},
	methods: {
		handleDeviceShare(row){
			this.$refs.devicesShare.show(row.id);
		},
		createUpdateForm(row) {
			if (row) {
				var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
				this.addOrUpdateForm = newObj;
			} else {
				this.addOrUpdateForm = {
				};
			}
		},
		beforeUpdate() {
		}
	},
	mounted: function() {
	}
};
</script>

<style scoped>
.el-dialog {
	width: 35% !important;
}
</style>




// WEBPACK FOOTER //
// src/view/front/group/team.vue